import request from '@/utils/request'

// 查询采购下单计划列表（复杂查询）
export function apiPlanPurchaseOrderList (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/listWithJoin',
    method: 'post',
    data: data
  })
}

// 查询组织供应商关系供应商列表
export function apiPlanPurchaseOrderGetSupplier (query) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/supplierList',
    method: 'get',
    params: query
  })
}

// 新增采购下单计划
export function apiScpPlanPurchaseOrderCreate (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder',
    method: 'post',
    data: data
  })
}

// 导出采购下单计划列表（复杂查询）
export function apiScpPlanPurchaseOrderExport (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/exportWithJoin',
    method: 'post',
    data: data
  })
}

// 下推采购下单计划
export function apiScpPlanPurchaseOrderPush (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/push',
    method: 'post',
    data: data
  })
}

// 触发工单生成采购下单(下载工单需求)
export function apiGeneratePurchaseOrder (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/generatePurchaseOrder',
    method: 'post',
    data: data
  })
}

// 修改采购下单计划
export function apiScpPlanPurchaseOrderEdit (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder',
    method: 'put',
    data: data
  })
}

// 批量修改采购下单期望交货日期
export function apiScpPlanPurchaseOrderBatchEditDemandDate (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/batchDemandDate',
    method: 'put',
    data: data
  })
}

// 取消采购下单计划
export function apiScpPlanPurchaseOrderCancel (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/cancel',
    method: 'post',
    data: data
  })
}

// 重新获取供应商
export function apiFlushPurchaseOrderSupplier (data) {
  return request({
    url: '/scp/scpPlanPurchaseOrder/flushPurchaseOrderSupplier',
    method: 'post',
    data: data
  })
}

// 查询采购叫料订单列表
export function apiMesProcurementCallOrderList (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/list',
    method: 'post',
    data: data
  })
}

// 采购叫料-编辑
export function apiMesProcurementCallOrderEdit (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/edit',
    method: 'put',
    data: data
  })
}

// 采购叫料-手工创建采购计划
export function apiMesProcurementCallOrderCreate (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/create',
    method: 'post',
    data: data
  })
}

// 采购叫料-下推采购叫料弹窗
export function apiMesQueryTradeOrderFromScm (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/queryTradeOrderFromScm',
    method: 'post',
    data: data
  })
}

// 采购叫料-创建时查询scm接口弹窗
export function apiMesQueryTradeOrderFromScmSingle (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/queryTradeOrderFromScmSingle',
    method: 'post',
    data: data
  })
}

// 采购叫料-手工创建采购计划确认接口
export function apiMesQueryTradeOrderCreate (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/create',
    method: 'post',
    data: data
  })
}

// 采购叫料-下载工单需求
export function apiMesQueryTradeOrderSyncData (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/syncData',
    method: 'post',
    data: data
  })
}

// 采购叫料-下推采购叫料订单到SCM系统
export function apiMesQueryTradeOrderPushToScm (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/pushToScm',
    method: 'post',
    data: data
  })
}

// 采购叫料-导出
export function apiMesQueryTradeOrderExport (data) {
  return request({
    url: '/mes/mesProcurementCallOrder/export',
    method: 'post',
    data: data
  })
}
